import styles from './Loader.module.scss';

export interface LoaderProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export const Loader = ({ ...props }: LoaderProps) => {
  return (
    <div
      {...props}
      className={`${styles.loader} ${props.className || ''}`}
      data-test-id="loader-container"
    >
      <Icon />
    </div>
  );
};

const Icon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="32"
    width="32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.511 12.844a10 10 0 107.07-6.547 1.5 1.5 0 01-.726-2.91 13 13 0 11-9.19 8.51 1.5 1.5 0 112.846.947z"
      fill="var(--brand-blue)"
      fillRule="evenodd"
    />
  </svg>
);
